import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
import "../../../styles/Auth/store.css"
const StorePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddStore = location.pathname === '/stores/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Name',
        'StoreManager',
        'Email',
        'Phone Number',
        'Action',
    ];
    const [previewUrl, setPreviewUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = sessionStorage.getItem("Token");
    const [searchQuery, setSearchQuery] = useState('');
    const [storesToDelete, setStoresToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editStoreId, setEditStoreId] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [formData, setFormData] = useState({
        storeName: '',
        branchName: '',
        phoneNumber: '',
        emailAddress: '',
        address: '',
        postalCode: '',
        state: '',
        country: '',
        managerName: '',
        managerEmail: '',
        description: ''
    });


    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const handleOpen = (storeId) => {
        setStoresToDelete(storeId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setStoresToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleAddStore = async (e) => {
        e.preventDefault();
        debugger;
        try {
            const token = sessionStorage.getItem("Token");
            const storeData = {
                storeName: formData.storeName,
                branchName: formData.branchName,
                phoneNumber: formData.phoneNumber,
                emailAddress: formData.emailAddress,
                address: formData.address,
                postalCode: formData.postalCode,
                state: formData.state,
                country: formData.country,
                managerName: formData.managerName,
                managerEmail: formData.managerEmail,
                description: formData.description
            };
            console.log("Sending store data:", storeData);

            const response = await postData('stores/', storeData, token);
            toast.success(response.message || 'Store added sucessfully');
            setFormData({
                storeName: '',
                branchName: '',
                phoneNumber: '',
                emailAddress: '',
                address: '',
                postalCode: '',
                state: '',
                country: '',
                managerName: '',
                managerEmail: '',
                description: ''
            });
            navigate('/stores');
            triggerRefresh();
        } catch (error) {
            console.error('Add Store Error:', error);
            toast.error(error.message || 'Add Store Failed');
        }
    }

    const handleUpdateStore = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const storeUpdateData = {
                storeName: formData.storeName,
                phoneNumber: formData.phoneNumber,
                emailAddress: formData.emailAddress,
                address: formData.address,
                postalCode: formData.postalCode,
                state: formData.state,
                country: formData.country,
                managerName: formData.managerName,
                managerEmail: formData.managerEmail,
                description: formData.description
            };
            console.log("Updating Store with data:", storeUpdateData);

            const response = await putData(`stores/store/${editStoreId}`, storeUpdateData, token);
            toast.success(response.message || 'Store updated successfully');
            setFormData({
                storeName: '',
                phoneNumber: '',
                emailAddress: '',
                address: '',
                postalCode: '',
                state: '',
                country: '',
                managerName: '',
                managerEmail: '',
                description: ''
            });
            triggerRefresh();
            navigate("/stores");
        } catch (error) {
            console.error("Update Store Error:", error);
            toast.error(error.message || 'Update Store Failed');
        }
    }

    const handleDeleteStore = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const response = await deleteData(`stores/store/${storesToDelete}`, token);
            toast.success(response.message || 'Store deleted successfully');
            setStoresToDelete(null);
            fetchStores(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete Store Error:", error);
            toast.error(error.message || 'Delete Store Failed');
        }
    }

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, emailAddress: value });

        // Simple email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) {
            setEmailError("Invalid email address");
        } else {
            setEmailError("");
        }
    };

    useEffect(() => {
        const token = sessionStorage.getItem("Token");
        fetchStores(currentPage, limit, searchQuery, token);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const fetchStores = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            storeName: searchQuery?.trim() || "",
        }
        try {
            setLoading(true);
            const response = await getData('stores/stores', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const customersList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setStores(customersList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            console.error("Failed to load stores", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="store-layout">
            <div className="store-content">
                <main className="store-main">
                    {isAddStore ? (
                        <div className="add-Store-form">
                            <h3>Add Store</h3>
                            <form className="Store-form" >
                                <div className="Store-form-row">
                                    <div className="Store-form-group">
                                        <label htmlFor="storeName" className="input-label">
                                            Branch Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Store name"
                                            required
                                            className="store-input"
                                            value={formData.branchName || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, branchName: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Store-form-group">
                                        <label htmlFor="emailAddress" className="input-label">
                                            Store Email Address
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Store Email Address"
                                            required
                                            className="store-input"
                                            disabled={!formData.branchName}
                                            value={formData.emailAddress || ""}
                                            onChange={handleEmailChange}
                                        />
                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                    </div>
                                </div>
                                <div className="Store-form-row">
                                    <div className="Store-form-group">
                                        <label htmlFor="phoneNumber" className="input-label">
                                            Store Phone Number
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Store Phone Number"
                                            required
                                            className="store-input"
                                            maxLength={10}
                                            value={formData.phoneNumber || ""}
                                            disabled={!formData.emailAddress}
                                            title="Mobile Number must be exactly 10 digits"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                            onBlur={() => {
                                                if (formData.phoneNumber.length !== 10) {
                                                    alert("Mobile Number must be exactly 10 digits");
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="Store-form-group">
                                        <label htmlFor="address" className="input-label">
                                            Address
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Store address"
                                            required
                                            className="store-input"
                                            value={formData.address || ""}
                                            disabled={!formData.phoneNumber}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, address: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Store-form-row">
                                    <div className="Store-form-group">
                                        <label htmlFor="postalCode" className="input-label">
                                            Postal Code
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Store Postal Code"
                                            required
                                            className="store-input"
                                            disabled={!formData.address}
                                            value={formData.postalCode || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, postalCode: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Store-form-group">
                                        <label htmlFor="state" className="input-label">
                                            State
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter  State"
                                            required
                                            className="store-input"
                                            disabled={!formData.postalCode}
                                            value={formData.state || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, state: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Store-form-row">
                                    <div className="Store-form-group">
                                        <label htmlFor="country" className="input-label">
                                            Country
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Country"
                                            required
                                            className="store-input"
                                            disabled={!formData.postalCode}
                                            value={formData.country || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, country: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Store-form-group">
                                        <label htmlFor="description" className="input-label">
                                            Description
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Description"
                                            className="store-input"
                                            value={formData.description || ""}
                                            disabled={!formData.country}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, description: e.target.value }))
                                            }
                                            style={{ height: '100px' }}
                                        />
                                    </div>
                                </div>
                                <div className="Store-form-row">

                                    <div className="Store-form-group">
                                        <div className="Store-buttons">
                                            <button className="cancel-Store-button" onClick={() => navigate('/stores')}>
                                                cancel
                                            </button>
                                            <button className="add-Store-button" type="submit" onClick={handleAddStore}>
                                                add Store
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="store-widgets">
                                <div className="store-widgets-header">
                                    <h3>Stores</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="store-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button className="add-btn-store" onClick={() => navigate('/stores/add')}>+ Add Store</button>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                overflow: 'auto',
                                maxHeight: '400px',
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow sx={{ backgroundColor: '#F7EAE2' }}>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stores.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No Stores found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            stores.map((store, index) => (
                                                <TableRow key={store._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{store.storeId || store.storeName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{store.managerName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{store.emailAddress}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{store.phoneNumber}</Typography></TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} style={{ cursor: "pointer" }} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    storeName: store.storeName,
                                                                    managerName: store.managerName,
                                                                    emailAddress: store.emailAddress,
                                                                    phoneNumber: store.phoneNumber,
                                                                    managerEmail: store.managerEmail,
                                                                    address: store.address,
                                                                    state: store.state,
                                                                    country: store.country,
                                                                    postalCode: store.postalCode,
                                                                    description: store.description
                                                                });
                                                                setEditStoreId(store._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                onClick={() => handleOpen(store._id)}
                                                            />
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="store-bottom">
                                <div className="store-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="product-section showing-range">
                                    {`Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`}
                                </div>
                                <div className="product-section spacer"></div>
                                <div className="product-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    storeName: '',
                                                    branchName: '',
                                                    phoneNumber: '',
                                                    emailAddress: '',
                                                    address: '',
                                                    postalCode: '',
                                                    state: '',
                                                    country: '',
                                                    managerName: '',
                                                    managerEmail: '',
                                                    description: ''
                                                });
                                            }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Store" : "Add Store"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateStore}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="storeName" className="input-label">Branch Name</label>
                                                        <input
                                                            type="text"
                                                            id="storeName"
                                                            name="branchName"
                                                            value={formData.branchName}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, branchName: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="emailAddress" className="input-label">Store Email Address</label>
                                                        <input
                                                            type="text"
                                                            id="emailAddress"
                                                            name="emailAddress"
                                                            value={formData.emailAddress}
                                                            onChange={handleEmailChange}
                                                        />
                                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="phoneNumber" className="input-label">Store Phone Number</label>
                                                        <input
                                                            type="text"
                                                            id="phoneNumber"
                                                            name="phoneNumber"
                                                            value={formData.phoneNumber}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits and max 10 characters
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (formData.phoneNumber.length !== 10) {
                                                                    alert("Mobile Number must be exactly 10 digits");
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="address" className="input-label">Store Address</label>
                                                        <input
                                                            type="text"
                                                            id="address"
                                                            name="address"
                                                            value={formData.address}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, address: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="postalCode" className="input-label">Postal Code</label>
                                                        <input
                                                            type="text"
                                                            id="postalCode"
                                                            name="postalCode"
                                                            value={formData.postalCode}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, postalCode: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="state" className="input-label">
                                                            State
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="state"
                                                            name="state"
                                                            value={formData.state}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, state: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="country" className="input-label">
                                                            Country
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="country"
                                                            name="country"
                                                            value={formData.country}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, country: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="input-label">
                                                            Description
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Description"
                                                            className="store-input"
                                                            value={formData.description || ""}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, description: e.target.value }))
                                                            }
                                                            style={{ height: '100px' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <div className="form-actions">
                                                            <button type="submit" className="btn-primary">
                                                                {isEditMode ? "Update Store" : "Add Store"}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn-secondary"
                                                                onClick={() => setIsPopupMode(false)}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && stores.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Stores
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Store?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteStore}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                </main>
            </div>
        </div>
    );

};

export default StorePage;
